import { AbstractControl,ValidatorFn } from "@angular/forms";

export function passwordValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value;
		let response = null;

        if (!value) {
            return null;
        }

		const hasUpperCase = /[A-Z]+/.test(value);
        const hasLowerCase = /[a-z]+/.test(value);
        const hasNumeric = /[0-9]+/.test(value);
		const hasSpecial = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value);

        const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial;

		if (!passwordValid) {
			response = {
				passwordStrength:true,
				hasUpperCase,
				hasLowerCase,
				hasNumeric,
				hasSpecial
			};
		}

		return response;
	};
}
